// extracted by mini-css-extract-plugin
module.exports = {"tab-item-area":"tab-item-area___2oZ-X","tab-item-status-item":"tab-item-status-item___39VdY"};